import { PageHeader } from "@/components/PageHeader";

export default function WipCheckPage() {
  return (
    <div className="flex flex-col bg-background">
      <PageHeader title="재공확인" />

      <main className="flex-1 p-6">
        <div className="container mx-auto">
          <p className="text-gray-600 dark:text-gray-400">
            This is wip-check page
          </p>
        </div>
      </main>
    </div>
  );
}
